import React from "react";
import { Link } from "react-router-dom";
import ServicePageTemplate from "./ServicePageTemplate";

const DomesticCleaningPage = () => {
  const pageData = {
    pageTitle: "Domestic Cleaning Cardiff | Regular House Cleaners | NeatWave",
    metaDescription: "Domestic cleaners in Cardiff, Barry and Penarth. Weekly, fortnightly, monthly and one-off house cleaning from £45. DBS-checked, fully insured cleaners. Request a free quote.",
    quoteService: "Regular Cleaning",
    heroImageAlt: "Clean, tidy living room after a regular domestic clean in Cardiff",
    
    heroTitle: "Domestic Cleaning in Cardiff",
    heroSubtitle: "Reliable house cleaners for weekly, fortnightly or one-off cleaning. Keep your Cardiff home spotless without giving up your evenings and weekends.",
    heroImage: "https://images.unsplash.com/flagged/photo-1573168710465-7f7da9a23a15?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMGhvbWV8ZW58MHx8fHwxNzc1OTA4OTc4fDA&ixlib=rb-4.1.0&q=85",
    
    serviceDescription: (
      <>
        <p className="mb-4">
          Life is busy - let NeatWave handle the cleaning. Our regular domestic cleaning service in Cardiff gives you back your free time while maintaining a spotless, healthy home environment. Choose weekly, fortnightly, or monthly service to suit your lifestyle and budget.
        </p>
        <h2>Regular house cleaning in Cardiff</h2>
        <p className="mb-4">
          Our domestic cleaners work across Cardiff, <Link to="/cleaning-services-barry">Barry</Link> and <Link to="/cleaning-services-penarth">Penarth</Link>. Where possible, we send the same cleaner each visit, so they learn your preferences and clean your home exactly how you like it. All our cleaners are DBS-checked, fully insured, and trained in eco-friendly cleaning practices.
        </p>
        <h3>Weekly, fortnightly and one-off cleaning</h3>
        <p className="mb-4">
          Weekly cleaning suits busy families and pet owners, fortnightly cleaning is great value for most homes, and one-off cleans are ideal before visitors arrive or after a busy period. Need something more thorough? Try a <Link to="/deep-cleaning-cardiff">deep clean</Link> first, then keep on top of it with regular visits.
        </p>
        <p className="mb-4">
          Flexible service that adapts to your needs - whether you're a busy professional, parent, or simply want more time for the things you enjoy. We bring all cleaning products and equipment, use eco-friendly products safe for families and pets, and work around your schedule.
        </p>
      </>
    ),
    
    whatIncluded: [
      {
        title: "Kitchen Cleaning",
        description: "Wipe down all surfaces, clean appliance exteriors, sink & taps, empty bins, sweep & mop floors"
      },
      {
        title: "Bathroom Cleaning",
        description: "Clean toilet, bath, shower, sink, mirrors, tiles, empty bins, sweep & mop floors"
      },
      {
        title: "Living Areas",
        description: "Dust all surfaces, TV unit, shelves, vacuum carpets, mop hard floors, tidy cushions"
      },
      {
        title: "Bedrooms",
        description: "Dust surfaces, make beds (if requested), vacuum carpets, organize items (with permission)"
      },
      {
        title: "Hallways & Stairs",
        description: "Vacuum stairs and carpets, mop hard floors, wipe down banisters"
      },
      {
        title: "General Tasks",
        description: "Empty all bins, light switches, door handles, skirting boards (on rotation)"
      }
    ],
    
    pricingInfo: {
      duration: "2-6 hours",
      price: "From £45",
      note: "Weekly cleaning from £45 (save 10%), fortnightly from £50 (save 5%), monthly from £65. Price depends on property size. Recurring bookings receive priority scheduling and discounted rates."
    },
    
    faqs: [
      {
        q: "How much does domestic cleaning cost in Cardiff?",
        a: "Regular domestic cleaning starts from £45 per visit. The price depends on the number of bedrooms and bathrooms and how often you book. Weekly cleans save 10% and fortnightly cleans save 5%."
      },
      {
        q: "Do you offer one-off house cleaning?",
        a: "Yes. As well as weekly and fortnightly cleaning, we offer one-off cleans, for example before guests arrive, after a party or when you need a fresh start."
      },
      {
        q: "How often should I have my home cleaned?",
        a: "It depends on your lifestyle! Weekly cleaning suits busy families, households with pets, or those who want consistently spotless homes. Fortnightly is our most popular option - great value and maintains cleanliness. Monthly works well for smaller properties or light use. We can advise based on your specific needs."
      },
      {
        q: "Will I have the same cleaner each time?",
        a: "Where possible, yes. We aim to send the same cleaner each visit so they get to know your home and preferences. If your regular cleaner is unavailable (holiday or illness), we'll send another trained cleaner who follows the same checklist."
      },
      {
        q: "Do I need to provide cleaning products?",
        a: "No, we bring all professional-grade, eco-friendly cleaning products and equipment. However, if you have preferred products or specific requirements (e.g., for allergies), we're happy to use yours instead."
      },
      {
        q: "What if I need to cancel or reschedule?",
        a: "We're flexible! Just give us 24 hours notice to cancel or reschedule without charge. We understand life happens - doctor appointments, work emergencies, family events. We'll work with you to find alternative times."
      },
      {
        q: "Can I request specific cleaning tasks?",
        a: "Absolutely! While we follow a standard checklist, we're happy to customize. Want extra attention in the kitchen? Prefer we skip dusting ornaments? Need inside windows done monthly? Just tell us your preferences when booking or anytime during service."
      }
    ],
    
    testimonial: {
      text: "An outstanding cleaning service, very polite, and an absolute pleasure to deal with. 5 stars.",
      author: "David Matthews, Google review"
    },
    
    relatedServices: [
      {
        title: "Deep Cleaning",
        description: "Quarterly intensive clean to maintain high standards",
        url: "/deep-cleaning-cardiff"
      },
      {
        title: "Oven Cleaning",
        description: "Add-on service for sparkling appliances",
        url: "/oven-cleaning-cardiff"
      },
      {
        title: "End of Tenancy Cleaning",
        description: "Moving home? We can help with that too",
        url: "/end-of-tenancy-cleaning-cardiff"
      }
    ]
  };

  return <ServicePageTemplate {...pageData} />;
};

export default DomesticCleaningPage;